import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { LogDetailsResponseModelDto } from ".";

export class LotDetailsResponseModel extends GlobalResponseObject{
    data?: LogDetailsResponseModelDto;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data string
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: LogDetailsResponseModelDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}